<script setup lang="ts">
import { computed, inject, ref } from 'vue';
import type { Ref } from 'vue';
import { storeToRefs } from 'pinia';
import type { FieldSchema } from '../../../types';
import { useSessionStore } from '@Stores';
import { GENDER } from '@AnimalModule';
import ANIMAL_NAMES from './constants';

withDefaults(
  defineProps<{
    error?: string;
    field?: FieldSchema;
    placeholder?: string;
    required?: boolean;
  }>(),
  {
    placeholder: 'components.forms.placeholder.common',
  }
);

const { shelterProfile } = storeToRefs(useSessionStore());

const model = defineModel<string>();

const genderModel = inject<Ref<string | undefined>>('animalGenderModel', ref());

const isNameGeneratorEnabled = computed(() => shelterProfile.value?.enable_name_generator ?? true);

const nameOptions = computed(() => {
  const { MALE, FEMALE } = ANIMAL_NAMES;
  const gender = String(genderModel.value ?? '').toLowerCase();

  if (gender === GENDER.MALE.toLowerCase()) return MALE;

  if (gender === GENDER.FEMALE.toLowerCase()) return FEMALE;

  return [...MALE, ...FEMALE];
});

// EVENTS
function onGenerateNameClick() {
  model.value = nameOptions.value[Math.floor(Math.random() * nameOptions.value.length)];
}
</script>

<template>
  <div>
    <AFieldInputText
      v-model="model"
      :error
      :field
      :placeholder="field?.settings.placeholder || placeholder"
      :required="field?.settings.required || required"
    />

    <Button
      v-if="isNameGeneratorEnabled"
      outlined
      class="mt-2 px-2 py-1 text-xs"
      icon="pi pi-sparkles"
      severity="secondary"
      :label="$t('animals.nameField.generateName')"
      @click="onGenerateNameClick"
    />
  </div>
</template>
